import { ModuleConfig } from '@/core/module';
import { paymentConfigRoutes } from './routes';

export const PaymentConfigModule: ModuleConfig = {
    name: 'payment-config',
    routes: paymentConfigRoutes,
    initialize: () => {
        console.log('Payment Config module initialized');
    }
};